import React from "react";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../../components/atoms/Navbar";
import { getAWBFailure, getAWBSuccess } from "../../../store/actions/awb";
import { searchAwb } from "../../../utils/api";
import { getOrderItems } from "../../../utils/functions";

const MobileItem = () => {
  const dispatch = useDispatch();

  const awbInfo = useSelector((store) => store.awbReducer);
  React.useEffect(() => {
    if (awbInfo?.data.length === 0) {
      async function getAwb() {
        let data = await searchAwb(
          JSON.parse(sessionStorage.getItem("awbNumber"))
        );

        if (data?.["code"] === "200") {
          dispatch(getAWBSuccess("data", data));
        } else {
          dispatch(getAWBFailure());
          // toast.error("Something went wrong!!", optionsToast);
        }
      }
      getAwb();
    }
  }, []);
  return (
    <div style={{height:"100vh"}}>
      <div className={styles.orderHistory}>
        <Navbar noLogo={true} title={"Items in the package"} />
      </div>
      <div className={styles.itemsPage}>
        <div className={`${styles.packageDes} ${styles.headerPackage}`}>
          <div style={{ width: "60%" }}>PRODUCT NAME</div>
          <div style={{ width: "20%" }}>QTY</div>
          <div style={{ width: "20%" }}>PRICE</div>
        </div>
        <hr className={styles.hrHeaderstyle}></hr>
        {getOrderItems(awbInfo?.data?.orderDetail).map((item) => {
          return (
            <div key={item.key}>
              <div className={`${styles.packageDes} ${styles.itemFont}`}>
                <div style={{ width: "60%" }}>{item.name}</div>
                <div style={{ width: "20%" }}>{item.quantity}</div>
                <div style={{ width: "20%" }}>{item.value}</div>
              </div>
              <hr className={styles.hrItemstyle}></hr>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MobileItem;
